import type { GridEventListener } from "@mui/x-data-grid-premium";
import { useCallback, useState } from "react";

interface GridColumnWidths {
  columnWidths: ReadonlyMap<string, number>;
  handleColumnWidthChange: GridEventListener<"columnWidthChange">;
}

const useGridColumnWidths = (): GridColumnWidths => {
  const [columnWidths, setColumnWidths] = useState<ReadonlyMap<string, number>>(() => new Map());
  const handleColumnWidthChange = useCallback<GridEventListener<"columnWidthChange">>(({ colDef, width }) => {
    setColumnWidths((previous) => {
      if (previous.get(colDef.field) === width) {
        return previous;
      }
      return new Map(previous).set(colDef.field, width);
    });
  }, []);

  return { columnWidths, handleColumnWidthChange };
};

export default useGridColumnWidths;
